const fetch = require('node-fetch');
const jwt_decode = require("jwt-decode");
import axios from 'axios'
//const TABLE_CENTRE = "centre";

const response = {
  statusCode: 500,
  body: JSON.stringify("Not implemented"),
  headers: {
    "Access-Control-Allow-Origin": "*",
    "Cache-Control": "no-store, no-cache, must-revalidate, proxy-revalidate, max-age=0, s-maxage=0",
    Pragma: "no-cache",
    Expires: "0"
  }
};

function mapSeNumbers(acl) {
  return acl.map((row) => row.split(" ")[0]);
}

export async function validateCentre(event) {

  const token = event.headers["id-token"];
  const decodedToken = jwt_decode(token);
  const aclArray = Array.isArray(decodedToken.acl)? decodedToken.acl : [decodedToken.acl];
  var seNumbers = mapSeNumbers(aclArray);

  const validRoles = ["SCHOOL.PRINCIPAL"];
  var rolesArray = [];
  if (Array.isArray(decodedToken.roles)) {
    rolesArray = [...decodedToken.roles];
  } else {
    rolesArray.push(decodedToken.roles);
  }
  const filteredRole = validRoles.filter(value => rolesArray.includes(value));
  let items = [];
  let service = [];

  if (
    !filteredRole.length &&
    !aclArray.some(role => role.match(/TTSDS Director/) || role.match(/TTSDS Educator/))
  ) {
    //callback("403: Unauthorized");
  } else {

    aclArray.forEach(acl => {
        let data = acl.substring(0,11);
        items.push(data);
    });

    if(items)
      items = items.filter(senumber => senumber !== "SE-00000000");
  }

  if (event.searchParams && event.searchParams.seNumber) {
    const seNumberEncoded = event.searchParams.seNumber;
    const seNumberDecoded = decodeURIComponent(seNumberEncoded);
    let seNumbersArray = seNumberDecoded.split(":");
    seNumbersArray = seNumbersArray.filter(senumber => senumber !== "SE-00000000");
    console.log("Revised SE numbers array", seNumbers);

    let endpoint = window.config.serverUrl + '/api/service-details/' + event.searchParams.seNumber;

    console.log("Searching Service Endpoint > " + endpoint);
    let tokenval = localStorage.getItem("id_token");
    await fetch(endpoint, {
      method: 'GET',
      headers: {
        'Access-Control-Allow-Origin': '*',
        'isportal': true,
        'ssotoken' : tokenval,
        'Content-Type': 'application/json'
      }
    })
    .then(result => result.json())
    .then(data => { 
      console.log("in if...",data)
      if (data.status?.statusCode === 404) {
        throw new Error('Service not found')
      }
      service.push(data)
      items.push(seNumbersArray[0])
      response.statusCode = 200
      response.body = service
    });
  } else {



    let services = [];

    // for (const item of items) {

    //   let url = window.config.serverUrl + '/api/service-details/';


    //   url = url + item;

    //   let tokenval = localStorage.getItem("id_token");


    //   await fetch(url, {
    //     method: 'GET',
    //     headers: {
    //       'Access-Control-Allow-Origin': '*',
    //       'isportal': true,
    //       'ssotoken' : tokenval,
    //       'Content-Type': 'application/json'
    //     }
    //   })
    //   .then(result => result.json())
    //   .then(data => { 
    //    // console.log("here it is..."+JSON.stringify(data))
    //     services.push(data)
    //     //items.push(seNumbersArray[0])
    //   });
    // }


      let url = window.config.serverUrl + '/api/service-details/';

      let tokenval = localStorage.getItem("id_token");

      const headers = {            
            'isportal': true,
            'ssotoken' : tokenval,
            'Content-Type': 'application/json'
      }
      services = await Promise.all( items.map((item) => axios.get(url + item, { headers} )));
      response.statusCode = 200
      response.body = services.map(s => s.data)
   // console.log("response body..."+JSON.stringify(response.body))
  }
  //console.log("searched..."+JSON.stringify(response))
  return response;
};
